import Vue from 'vue'
import Router from 'vue-router'
import AdminRouter from '@/router/admin'
import FrontRouter from '@/router/front'

Vue.use(Router)

let routes = new Set([...AdminRouter,...FrontRouter])

export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js